import Empty from "../empty";

export function EmptyData() {
  return (
    <div className='flex flex-col gap-2 items-center p-8 bg-[#f2f4f6] rounded-md border border-[#e2e8f0] mb-5'>
      <Empty />
      <p className='text-[#b2b2b2] text-[12px]'>Nenhum registro encontrado.</p>
    </div>
  )
}